const NoNeedListenerElements = ['HTML', 'HEAD', 'SCRIPT', 'STYLE', 'LINK', 'META', 'TITLE', 'NOSCRIPT']

export default class BuryService{
	constructor({config, mobile} = {}) {
	    this.config = config
		this.mobile = mobile
		this.vueInstance = mobile.vueInstance
		
		this.init()
	}
	
	init(){
		if(!window.BURY_INIT){
			window.BURY_INIT = true
			console.log(document.querySelectorAll('*'))
			//const allEles = document.querySelectorAll('*').filter(ele => )
		}
	}
}